import './UploadActivityButton.css';

interface UploadActivityButtonProps {
  onClick: () => void;
  isUploading: boolean;
  isSuccess: boolean;
  disabled?: boolean;
}

export function UploadActivityButton({ onClick, isUploading, isSuccess, disabled }: UploadActivityButtonProps) {
  const isDisabled = disabled || isUploading;
  return (
    <button
      className={`upload-activity-button ${isSuccess ? 'success' : ''} ${isDisabled && !isUploading ? 'permanently-disabled' : ''}`}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      aria-label="Upload activity"
      title="Upload activity"
    >
      <img
        src="/assets/chat-ui/Boton_Subir.png"
        alt="Subir"
        className="upload-activity-icon"
      />
      {isSuccess && (
        <span className="upload-activity-check">
          <img src="/assets/selection/check.png" alt="" aria-hidden="true" />
        </span>
      )}
    </button>
  );
}
